/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {}
 */
export interface KeySearchRequest {
    /** The filter to apply to the search. */
    filter?: Truvity.KeyFilter[];
    /** The sort order to apply to the search. */
    sort?: Truvity.KeySort[];
}
